export interface TermsAndConditionLine {
    status: ResponseStatusLine,
    action?: ActionStatusLine,
    termConditionId?: number
}

export enum ResponseStatusLine{
    COMPLETED = 'completed', // หลัง save เรียบร้อยแล้ว
    SUCCESS = 'success', // หลัง terms cond accept
    FAIL = 'fail', // terms cond ไม่สำเร็จ
    SKIP = 'skip', // ข้าม terms cond
}

export enum ActionStatusLine{
    ACCEPT = 'accept',
    CANCEL = 'cancel'
}